import { render, staticRenderFns } from "./noticeMultipleSelect.vue?vue&type=template&id=2af961bf"
import script from "./noticeMultipleSelect.vue?vue&type=script&lang=js"
export * from "./noticeMultipleSelect.vue?vue&type=script&lang=js"
import style0 from "./noticeMultipleSelect.vue?vue&type=style&index=0&id=2af961bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports